import React from 'react';
import LOGO_HEADER from '../assets/images/logo.png';

export default function Logo({campaign, textAlign}) {
  let align = textAlign ? textAlign : 'center';
  return (
    <div className={`logo ${align}`}>
      <div className="logo-wrap">
        <img src={LOGO_HEADER} alt="GameIF" />
      </div>
      <span className="title-campaign">{ campaign }</span>
    </div>
  );
}